export default {
  toDealWith: 'One step to submit settlement request',
  dealWithtips: 'You need to upload the signed document with company chop stamped.',
  tip: 'Friendly Reminder',
  loading: 'Loading...',
  loginTimeout: 'Login timeout',
  errorMsg: 'Error message',
  systemError: 'System Error',
  pageIsLost: 'Sorry, the page cannot be found',
  reLogin: 'Re-Login',
  loginMsg: 'Login again',
  save: 'Save',
  cancel: 'Cancel',
  search: 'Search',
  reset: 'Reset',
  confirm: 'Confirm',
  opera: 'Operation {tips}',
  downloadFile: 'File Download',
  yes: 'Yes',
  no: 'No',
  underSubmission: 'Submitting ...',
  prevText: 'Page up',
  nextText: 'Page down',
  keyWord: 'Keyword',
  all: 'All',
  jan: 'Jan',
  feb: 'Feb',
  mar: 'Mar',
  apr: 'Apr',
  may: 'May',
  jun: 'Jun',
  jul: 'Jul',
  aug: 'Aug',
  sep: 'Sep',
  oct: 'Oct',
  nov: 'Nov',
  dec: 'Dec',
  to: 'to',
  add: 'Add',
  state: 'Status',
  showImg: 'image display',
  close: 'close',
  followRemark: 'Follow up remarks',
  plsSelect: 'please choose',
  submit:'submit',
  remark:'remark',
  cancelled:'cancelled',
  importantHint:'important hint',
  alreadyExists:'already exists',
  type: 'Type',
  name: 'Name',
  size: 'Size',
  download: 'Download',
  reUpload: 'Re-Upload',
  delete: 'Delete',
  append: 'Append',
  remove: 'Remove',
  edit: 'Edit',
  national: 'Nationality',
  gender: 'Gender',
  birthday: 'Birth Date',
  birthPlace: 'Place of Birth',
  motherTongue: 'Mother Language',
  race: 'Ethnicity',
  tuitionFee: 'Tuition Fee',
  idCard: 'ID Card',
  passport: 'Passport',
  issueDate: 'Issue Date',
  expireDate: 'Expire Date',
  issueState: 'Issuing State/area',
  grade: 'Grede',
  curriculum: 'Curriculum',
  homeTel: 'Home Phone',
  mobile: 'Mobile Phone',
  email: 'Email',
  homePlace: 'Residential Address',
  dontHave: 'Dont Have',
  lastWeek: 'Last week',
  lastMonth: 'Last month',
  lastThreeMonths: 'Last three months',
  serialNumber: 'Seq',
  check: 'Check',
  active: 'Active',
  gmtCreateUser: 'Created By',
  gmtCreate: 'Created Time',
  refresh: 'Refresh',
  wechat: 'Wechat',
  cancelAndClose: 'Cancel and Close',
  role: 'Role',
  searchPlaceholder: 'Please enter the keyword',
  viewMore: 'View More',
  noPermission: 'No Permission',
  company: 'Company',
  personalAccountCompany: 'Personal Account for Company',
  person: 'Person',
  studio: 'Studio',
  internationalSchool: 'International School',
  other: 'Other',
  return: 'Return',
  submitSuccess: 'Submit Successfully',
  submitFail: 'Submit Fail',
  telephone: 'Telephone',
  onlineForm: 'Online form',
  downloadForm: 'Download form',
  resourceManagementItemName1: 'Australia and New Zealand',
  resourceManagementTitle: 'Institutional Guidelines and Application Fees',
  noData: "There is no data!",
  studentsCount: 'Total {total} students',
  applicationCount: '{totalApply} applications',
  fileUploadTips: 'Unsupported file format. Please upload a valid file.',
  fileUploadTips2: 'File size must not exceed {size}MB. Please re-upload a valid file.',
  quickAccess: 'Quick Access',
  preview: 'Preview',
  continue: 'Continue',
  focusCityTips: 'Please select country / province.',
  focusProvinceTips: 'Please select country.',
  dataTotalNumber: '{totalNumber} record(s)',
  gearUpdateReminder:'GEAR Update Reminder',
  errorCode: 'Error Code',
};
